import styled from '@emotion/styled';

export const RegisterContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, rgba(165, 80, 255, 1) 0%, rgba(118, 72, 200, 1) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  
  /* 🔧 수정: 스크롤 지원 추가 */
  overflow-y: auto;
  
  /* 세로로 긴 화면에서도 적절한 배치 */
  @media (max-height: 800px) {
    align-items: flex-start;
    padding-top: 40px;
    padding-bottom: 40px;
  }
  
  @media (max-height: 700px) {
    padding-top: 30px;
    padding-bottom: 30px;
  }
`;

export const RegisterCard = styled.div`
 width: 100%;
 max-width: 600px;
 background: #ffffff;
 border-radius: 16px;
 box-shadow: 0px 20px 60px rgba(0, 0, 0, 0.1);
 padding: 48px 40px;
 box-sizing: border-box;
 
 /* 🔧 수정: 유연한 높이 설정 */
 margin: auto;
 max-height: calc(100vh - 40px);
 overflow-y: auto;
 
 /* 작은 화면에서의 반응형 처리 */
 @media (max-width: 768px) {
   max-width: 100%;
   padding: 32px 24px;
   border-radius: 12px;
   margin: 20px 0;
   max-height: calc(100vh - 40px);
 }
 
 /* 🔧 추가: 작은 화면 높이에서의 처리 */
 @media (max-height: 700px) {
   padding: 32px 28px;
   margin: 15px 0;
   max-height: calc(100vh - 30px);
 }
 
 @media (max-height: 600px) {
   padding: 24px 24px;
   margin: 10px 0;
   max-height: calc(100vh - 20px);
 }
 
 @media (max-width: 480px) and (max-height: 700px) {
   padding: 20px 18px;
   margin: 10px 0;
   max-height: calc(100vh - 20px);
 }
`;

export const RegisterHeader = styled.div`
  text-align: center;
  margin-bottom: 40px;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 700px) {
    margin-bottom: 30px;
  }
  
  @media (max-height: 600px) {
    margin-bottom: 24px;
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 32px;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 700px) {
    margin-bottom: 24px;
  }
  
  @media (max-height: 600px) {
    margin-bottom: 16px;
  }
`;

export const LogoIcon = styled.div`
  font-size: 32px;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 28px;
  }
`;

export const LogoText = styled.h1`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  line-height: 29px;
  font-weight: 700;
  margin: 0;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const RegisterTitle = styled.h2`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 28px;
  line-height: 36px;
  font-weight: 600;
  margin: 0 0 8px 0;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 700px) {
    font-size: 26px;
    line-height: 32px;
  }
  
  @media (max-height: 600px) {
    font-size: 24px;
    line-height: 30px;
    margin: 0 0 6px 0;
  }
`;

export const RegisterSubtitle = styled.p`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin: 0;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const ServerStatus = styled.div`
  margin: 16px 0 0 0;
  padding: 12px 16px;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  text-align: center;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 600px) {
    margin: 12px 0 0 0;
    padding: 10px 14px;
    font-size: 13px;
    line-height: 18px;
  }
  
  ${({ status }) => {
    if (status === 'checking') {
      return `
        background: rgba(106, 66, 242, 0.1);
        border: 1px solid rgba(106, 66, 242, 0.2);
        color: #6A42F2;
      `;
    } else if (status === 'offline') {
      return `
        background: rgba(255, 75, 75, 0.1);
        border: 1px solid rgba(255, 75, 75, 0.2);
        color: #FF4B4B;
      `;
    } else if (status === 'online') {
      return `
        background: rgba(0, 148, 68, 0.1);
        border: 1px solid rgba(0, 148, 68, 0.2);
        color: #009444;
      `;
    }
  }}
`;

export const RetryButton = styled.button`
  margin-left: 12px;
  padding: 4px 12px;
  background: #FF4B4B;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.9;
  }
`;

export const RegisterForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 700px) {
    gap: 18px;
  }
  
  @media (max-height: 600px) {
    gap: 16px;
  }
`;

export const FormRow = styled.div`
  display: flex;
  gap: 16px;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 600px) {
    gap: 14px;
  }
  
  @media (max-width: 600px) {
    flex-direction: column;
    gap: 16px;
  }
  
  @media (max-width: 600px) and (max-height: 600px) {
    gap: 14px;
  }
`;

export const FormGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 600px) {
    gap: 5px;
  }
`;

export const FormLabel = styled.label`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 13px;
    line-height: 18px;
  }
`;

export const FormInput = styled.input`
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background: #ffffff;
  border: 2px solid ${({ hasError }) => hasError ? '#FF4B4B' : '#e5e7eb'};
  padding: 12px 16px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #333333;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
  
  /* 🔧 추가: 작은 화면에서 높이 조정 */
  @media (max-height: 700px) {
    height: 46px;
    padding: 11px 15px;
    font-size: 15px;
    line-height: 23px;
  }
  
  @media (max-height: 600px) {
    height: 44px;
    padding: 10px 14px;
    font-size: 15px;
    line-height: 22px;
  }
  
  &:focus {
    outline: none;
    border-color: ${({ hasError }) => hasError ? '#FF4B4B' : '#6A42F2'};
  }
  
  &::placeholder {
    color: #9ca3af;
  }
  
  &:disabled {
    background: #f9fafb;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const PasswordInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const PasswordToggle = styled.button`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 20px;
  color: #666666;
  transition: color 0.2s ease;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    right: 14px;
    font-size: 18px;
  }
  
  &:hover:not(:disabled) {
    color: #333333;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const FieldError = styled.div`
  color: #FF4B4B;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  margin-top: 4px;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 11px;
    line-height: 15px;
    margin-top: 3px;
  }
`;

export const ErrorMessage = styled.div`
  color: #FF4B4B;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  background: rgba(255, 75, 75, 0.1);
  border: 1px solid rgba(255, 75, 75, 0.2);
  border-radius: 6px;
  padding: 12px 16px;
  text-align: center;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 13px;
    line-height: 18px;
    padding: 10px 14px;
  }
`;

export const TermsWrapper = styled.div`
  margin: 8px 0;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 600px) {
    margin: 6px 0;
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 600px) {
    gap: 10px;
  }
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  border-radius: 4px;
  background: #ffffff;
  border: 2px solid ${({ hasError }) => hasError ? '#FF4B4B' : '#e5e7eb'};
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 2px;
  flex-shrink: 0;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    width: 16px;
    height: 16px;
    margin-top: 1px;
  }
  
  &:checked {
    background: #6A42F2;
    border-color: #6A42F2;
  }
  
  &:focus {
    outline: 2px solid rgba(106, 66, 242, 0.3);
    outline-offset: 2px;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CheckboxLabel = styled.label`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  cursor: pointer;
  
  /* 🔧 추가: 작은 화면에서 크기 조정 */
  @media (max-height: 600px) {
    font-size: 13px;
    line-height: 18px;
  }
  
  span {
    color: #6A42F2;
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
    
    &:hover {
      opacity: 0.8;
    }
  }
`;

export const TermsLink = styled.span`
  color: #6A42F2;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.8;
  }
`;


export const SubmitButton = styled.button`
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background: #6A42F2;
  border: none;
  cursor: pointer;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  transition: opacity 0.2s ease;
  margin-top: 8px;
  
  /* 🔧 추가: 작은 화면에서 높이 조정 */
  @media (max-height: 700px) {
    height: 46px;
    font-size: 15px;
    line-height: 23px;
    margin-top: 6px;
  }
  
  @media (max-height: 600px) {
    height: 44px;
    font-size: 15px;
    line-height: 22px;
    margin-top: 4px;
  }
  
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
  
  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const LoginLink = styled.p`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  text-align: center;
  margin: 32px 0 0 0;
  
  /* 🔧 추가: 작은 화면에서 간격 조정 */
  @media (max-height: 700px) {
    margin: 24px 0 0 0;
    font-size: 13px;
    line-height: 19px;
  }
  
  @media (max-height: 600px) {
    margin: 20px 0 0 0;
    font-size: 13px;
    line-height: 18px;
  }
  
  a {
    color: #6A42F2;
    font-weight: 600;
    text-decoration: none;
    transition: opacity 0.2s ease;
    
    &:hover {
      opacity: 0.8;
      text-decoration: underline;
    }
  }
`;